import { NgClass } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  Type,
  ViewChild,
} from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core'
import { FormlyFieldInput } from '@ngx-formly/ng-zorro-antd/input'
import { AngularSvgIconModule } from 'angular-svg-icon'
import { NzBytesPipe } from 'ng-zorro-antd/pipes'
import { NzProgressComponent } from 'ng-zorro-antd/progress'
import {
  NzUploadComponent,
  NzUploadFile,
  NzUploadXHRArgs,
} from 'ng-zorro-antd/upload'
import { Subscription } from 'rxjs'

import { ButtonComponent } from '../../../button/button.component'
import { FormlyFieldProps } from '../common.types'

interface UploadProps extends FormlyFieldProps {
  handleUpload?(item: NzUploadXHRArgs): Subscription
}

export interface FormlyUploadFieldConfig
  extends FormlyFieldConfig<UploadProps> {
  type: 'file' | Type<FormlyFieldInput>
}

@Component({
  selector: 'app-upload-field-type',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    NzUploadComponent,
    ButtonComponent,
    NzProgressComponent,
    NzBytesPipe,
    NgClass,
    AngularSvgIconModule,
  ],
  templateUrl: './upload-field-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadFieldTypeComponent extends FieldType implements OnInit {
  @ViewChild('uploadComponent', { static: true })
  public uploadComponent!: NzUploadComponent
  public fileList: NzUploadFile[] = []

  public ngOnInit(): void {
    this.fileList = this.field.formControl?.value
    this.uploadComponent.ngOnChanges()
    // this.uploadComponent.ngAfterViewInit()
  }

  public handleChange(): void {
    this.formControl.setValue(this.fileList)
    this.formControl.markAsDirty()
    this.formControl.markAsTouched()
  }

  public removeFile(preview: NzUploadFile): void {
    this.uploadComponent.onRemove(preview)
    this.handleChange()
  }
}
